import { registerPlugin } from '@capacitor/core';

export interface ExternalNavigationPlugin {
  openUrl(options: { url: string }): Promise<{ url: string }>;
}

export const ExternalNavigation = registerPlugin<ExternalNavigationPlugin>('ExternalNavigation', {
  web: () => import('./externalNavigationWeb').then((module) => new module.ExternalNavigationWeb()),
});
